import React from 'react';
import { Tooltip } from './Tooltip';

type LinkWithTooltipProps = {
  url: string;
};

export const LinkWithTooltip: React.FC<LinkWithTooltipProps> = ({ url }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-w-0 w-full">
      <Tooltip content={url}>
        <a
          href={url}
          onClick={handleClick}
          className="text-black underline cursor-pointer block overflow-hidden text-ellipsis whitespace-nowrap w-full"
          target="_blank"
          rel="noopener noreferrer"
        >
          {url}
        </a>
      </Tooltip>
    </div>
  );
};
